import React, {VoidFunctionComponent, ReactElement} from 'react';

import styles from './info-window-content.module.css';

interface Props {
  title: string;
  year: string;
  artist: string;
}

const InfoWindowContent: VoidFunctionComponent<Props> = (
  props
): ReactElement => {
  const {title, year, artist} = props;

  return (
    <div className={styles.content}>
      <h5>
        {artist}
        <br />
        {title}
      </h5>
      <p>{year}</p>
    </div>
  );
};
export default InfoWindowContent;
